import { handleActions } from "redux-actions";
import {
  FETCH_CURRENT_USER_SUCCESS,
  SET_LOADING,
  SET_UPDATES_LOADING,
  FETCH_TABLE_SUCCESS,
  SET_DATE,
  SET_TOGGLE
} from "./RiskMembersSagas";

export const initialState = {
  currentUser: {},
  isLoading: false,
  updatesLoading: false,
  date: "",
  table: {},
  scorecards: [],
  includeFutureVisits: true
};

export default handleActions(
  {
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_DATE]: (state, action) => ({
      ...state,
      date: action.payload
    }),
    [SET_UPDATES_LOADING]: (state, action) => ({
      ...state,
      updatesLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload
    }),
    [FETCH_TABLE_SUCCESS]: (state, action) => ({
      ...state,
      table: action.payload,
      scorecards: action.payload.chart_values
    }),
    [SET_TOGGLE]: (state, action) => ({
      ...state,
      includeFutureVisits: action.payload
    })
  },

  initialState
);
